/* eslint-disable react-hooks/exhaustive-deps */
import React, {useEffect, useMemo, useState} from 'react'
import {useNavigate} from 'react-router-dom'

import ImageUploader from '../../../../components/ImageUploader/ImageUploader'
import LoadingComponent from '../../../../components/LoadingComponent/LoadingComponent'
import notifyToast from '../../../../components/Toast/Toast'

import {
    getFmkNalogaStavkaData,
    jelAktivanUtovarZaNalog,
    utovariFmkNalog,
    zavrsiUtovarFmkNaloga
} from '../../../../api/fmkNalozi'
import {ToastContainer} from 'react-toastify'

type Props = {
    nalog: string
    onBack: () => void
}

const StepStartTransport: React.FC<Props> = ({nalog, onBack}) => {

    const [loading, setLoading] = useState(true)
    const [starting, setStarting] = useState(false)
    const [stopping, setStopping] = useState(false)

    const [dataNaloga, setDataNaloga] = useState<any>(null)
    const [dataStavka, setDataStavka] = useState<any[]>([])

    const [utovarActive, setUtovarActive] = useState(false)
    const [checkingUtovar, setCheckingUtovar] = useState(true)

    const [checkedIds, setCheckedIds] =
        useState<Record<string, boolean>>({})

    const brojNaloga = nalog

    const [images, setImages] = useState<File[]>([])

    const nalogSafe = brojNaloga.replace(/\//g, '-')
    const [isUploadingImages, setIsUploadingImages] = useState(false)
    const [uploadedImages, setUploadedImages] = useState<any[]>([])

    const navigate = useNavigate()
    const reloadAll = async () => {

        setLoading(true)
        setCheckingUtovar(true)

        try {

            const [fmk, active] = await Promise.all([
                getFmkNalogaStavkaData({nalog}),
                jelAktivanUtovarZaNalog({brojNaloga})
            ])

            setDataNaloga(fmk?.nalog)
            setDataStavka(fmk?.stavka ?? [])
            setUtovarActive(Boolean(active))

        } catch (e: any) {
            notifyToast(false, e?.response?.data?.message)
        } finally {
            setLoading(false)
            setCheckingUtovar(false)
        }
    }

    useEffect(() => {
        reloadAll()
    }, [nalog])

    const isLoaded = (s: any) =>
        !!s?.uposlenik_utovario ||
        !!s?.utovarioStavku ||
        !!s?.utovarioStavkuDatum

    const selectableStavke =
        useMemo(() => dataStavka.filter(s => !isLoaded(s)), [dataStavka])

    const loadedStavke =
        useMemo(() => dataStavka.filter(isLoaded), [dataStavka])

    const toggleOne = (id: string) => {
        setCheckedIds(prev => ({
            ...prev,
            [id]: !prev[id]
        }))
    }

    const allChecked =
        selectableStavke.length > 0 &&
        selectableStavke.every(s => checkedIds[String(s.Id)])

    const toggleAll = (value: boolean) => {

        const next: Record<string, boolean> = {}

        selectableStavke.forEach(s => {
            next[String(s.Id)] = value
        })

        setCheckedIds(next)
    }

    const onStartUtovar = async () => {

        const selected =
            Object.keys(checkedIds)
                .filter(id => checkedIds[id])

        setStarting(true)

        try {

            await utovariFmkNalog({
                brojNaloga: brojNaloga,
                stavke: selected.map(id => ({
                    Id: Number(id)
                }))
            })

            setUtovarActive(true)

            notifyToast(true, 'Utovar zapocet.')

            setTimeout(() => {
                navigate(-1)
            }, 3000)


        } catch (e: any) {
            notifyToast(false, e?.response?.data?.message)
        } finally {
            setStarting(false)
        }
    }

    const onStopUtovar = async () => {
        setStopping(true)
        try {
            const response = await zavrsiUtovarFmkNaloga({brojNaloga})
            notifyToast(true, response.message)

            setTimeout(() => {
                navigate(-1)
            }, 3000)

        } catch (e:any) {
            notifyToast(false, e?.response?.data?.message)
            setStopping(false)
        }
    }

    const formatDate24 = (date?: string) => {
        if (!date) return ''

        const d = new Date(date.replace(' ', 'T'))

        return d.toLocaleString('hr-BA', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            hour12: false
        })
    }

    if (loading)
        return (
            <div className='card border-0 shadow-sm'>
                <div className='card-body p-10 text-center'>
                    <LoadingComponent/>
                    <div className='text-muted fw-semibold mt-4'>Ucitavanje naloga...</div>
                </div>
            </div>
        )

    return (
        <div className='card border shadow-sm overflow-hidden'>
            <ToastContainer />
            <div
                className='card-header border-0 d-flex align-items-center justify-content-between gap-3 px-4 py-3 bg-white'
            >
                <div className='d-flex align-items-center gap-3'>
                    <div
                        className='d-flex align-items-center justify-content-center rounded bg-light-primary'
                        style={{width: 40, height: 40, flex: '0 0 40px'}}
                    >
                        <i className='bi bi-box-seam text-primary fs-3'/>
                    </div>
                    <div>
                        <h2 className='mb-0 text-gray-900 fw-bolder' style={{fontSize: 18, lineHeight: 1.2}}>
                            Nalog #{brojNaloga}
                        </h2>
                        <div className='text-muted fw-semibold fs-8'>Obrada utovara</div>
                    </div>
                </div>

                <div className='d-flex align-items-center'>
                    <span className={`badge ${utovarActive ? 'badge-light-success' : 'badge-light-warning'} fw-bold px-3 py-2`}>
                        {utovarActive ? 'Utovar aktivan' : 'Spreman za start'}
                    </span>
                </div>
            </div>

            <div className='card-body p-3 p-md-5'>

                <div className='row g-3 mb-4'>
                    <div className='col-12 col-lg-6'>
                        <div className='border rounded bg-light px-3 py-2 h-100'>
                            <div className='text-muted fw-semibold text-uppercase fs-9 mb-1'>Kupac</div>
                            <div className='fw-bolder text-gray-900 text-break'>{dataNaloga?.Kupac || '-'}</div>
                        </div>
                    </div>
                    <div className='col-12 col-lg-6'>
                        <div className='border rounded bg-light px-3 py-2 h-100'>
                            <div className='text-muted fw-semibold text-uppercase fs-9 mb-1'>Komercijalista</div>
                            <div className='fw-bolder text-gray-900 text-break'>{dataNaloga?.Korisnik || '-'}</div>
                        </div>
                    </div>
                </div>

                {selectableStavke.length > 0 && (
                    <div className='d-flex align-items-center justify-content-between gap-3 mb-3'>
                        <div>
                            <h3 className='fw-bolder text-gray-900 mb-0' style={{fontSize: 17}}>Stavke za utovar</h3>
                            <div className='text-muted fw-semibold fs-8'>Odaberi stavke za ovaj utovar.</div>
                        </div>

                        <label className='form-check form-check-custom form-check-solid bg-light border rounded px-3 py-2 mb-0'>
                            <input
                                type='checkbox'
                                className='form-check-input me-2'
                                checked={allChecked}
                                onChange={(e)=>toggleAll(e.target.checked)}
                            />
                            <span className='form-check-label fw-bold text-gray-800 fs-8'>
                                Sve
                            </span>
                        </label>
                    </div>
                )}

                <div className='d-flex flex-column gap-2 mb-4'>
                    {selectableStavke.map(stavka => {

                        const id = String(stavka.Id)

                        return (
                            <label
                                key={id}
                                className='border rounded bg-white p-3 d-flex justify-content-between align-items-start gap-3'
                                style={{cursor: 'pointer'}}
                            >
                                <div className='d-flex align-items-start gap-3 min-w-0'>
                                    <input
                                        type='checkbox'
                                        className='form-check-input mt-1'
                                        checked={!!checkedIds[id]}
                                        onChange={() => toggleOne(id)}
                                    />

                                    <div className='min-w-0'>
                                        <div className='fw-bolder text-gray-900'>{stavka.IdArtikla}</div>
                                        <div className='text-muted fw-semibold text-break fs-8'>
                                            {stavka.Naziv}
                                        </div>
                                    </div>
                                </div>

                                <span className='badge badge-light-primary fw-bold px-3 py-2 flex-shrink-0'>
                                    {stavka.Kolicina} {stavka.IdJedMjere}
                                </span>
                            </label>
                        )
                    })}
                </div>
                {loadedStavke.length > 0 && (
                    <>
                        <div className='d-flex align-items-center gap-2 mb-3'>
                            <span className='badge badge-light-success fw-bold px-3 py-2'>
                                {loadedStavke.length}
                            </span>
                            <h3 className='fw-bolder text-gray-900 mb-0' style={{fontSize: 17}}>Utovarene stavke</h3>
                        </div>

                        <div className='d-flex flex-column gap-2 mb-4'>
                            {loadedStavke.map(s => (

                                <div
                                    key={s.Id}
                                    className='border rounded bg-light p-3 d-flex justify-content-between align-items-start gap-3'
                                    style={{
                                        borderRight: `6px solid ${s.statusi?.Boja || '#50cd89'}`,
                                    }}
                                >

                                    <div className='min-w-0'>
                                        <div className='fw-bolder text-gray-900'>{s.IdArtikla}</div>

                                        <div className='text-muted fw-semibold text-break fs-8'>
                                            {s.Naziv}
                                        </div>

                                        <div className='text-success fw-semibold mt-1 fs-8'>
                                            <i className='bi bi-check2-circle me-2'/>
                                            Utovario:{' '}
                                            <b>
                                                {s.uposlenik_utovario?.UposlenikImePrezime}
                                            </b>
                                            <br/>
                                            <span className='text-muted'>
                                                <i className='bi bi-clock me-2'/>
                                                {formatDate24(s.utovarioStavkuDatum)}
                                            </span>
                                        </div>
                                    </div>

                                    <span className='badge badge-light-success fw-bold px-3 py-2 flex-shrink-0'>
                                        {s.Kolicina} {s.IdJedMjere}
                                    </span>

                                </div>

                            ))}
                        </div>
                    </>
                )}
                {utovarActive && (
                    <>
                        <div className='separator my-4'/>
                        <ImageUploader
                            nalogSafe={nalogSafe}
                            onUploadingChange={setIsUploadingImages}
                            onUploadedChange={setUploadedImages}
                        />
                    </>
                )}

                <div className='separator my-4'/>

                <div className='d-flex flex-column flex-md-row gap-3'>

                    {checkingUtovar ? (
                        <button className='btn btn-light w-100 py-3 fw-bold' disabled>
                            <span className='spinner-border spinner-border-sm me-2'/>
                            Provjera...
                        </button>
                    ) : utovarActive ? (
                        <button
                            className='btn btn-danger w-100 py-3 fw-bold'
                            onClick={onStopUtovar}
                            disabled={stopping || isUploadingImages}
                        >
                            {isUploadingImages ? (
                                <>
                                    <span className='spinner-border spinner-border-sm me-2'/>
                                    Upload u toku...
                                </>
                            ) : (
                                <>
                                    <i className='bi bi-stop-circle me-2'/>
                                    Stop utovara
                                </>
                            )}
                        </button>
                    ) : (
                        <button
                            className='btn btn-success w-100 py-3 fw-bold'
                            onClick={onStartUtovar}
                            disabled={starting}
                        >
                            {starting ? (
                                <>
                                    <span className='spinner-border spinner-border-sm me-2'/>
                                    Startanje...
                                </>
                            ) : (
                                <>
                                    <i className='bi bi-play-circle me-2'/>
                                    Start utovara
                                </>
                            )}
                        </button>
                    )}

                    <button
                        className='btn btn-light w-100 w-md-auto py-3 px-6 fw-bold'
                        onClick={onBack}
                    >
                        <i className='bi bi-arrow-left me-2'/>
                        Nazad
                    </button>
                </div>

            </div>
        </div>
    )
}

export default StepStartTransport
